<template>
    <div id="headerBg" :style="headerBg"></div>
</template>

<script>
export default {
    props:{
        headerBg:{
            type:[Object]
        }
    },
    data(){
        return{
          
        }
    },
    mounted(){
        
    },
}
</script>

<style>
#headerBg{
    width: 100%;
    height: 100%;
    z-index: -1;
}
</style>